<template>
  <div class="selectrow">
    <label>{{ title }}</label>
    <div class="row form-group2">
      <el-select
        :disabled="disabled"
        :value="value"
        class="col-md-8 select-info"
        size="large"
        @input="$emit('input', $event)"
      >
        <!-- <option disabled value="">Please select one</option> -->
        <el-option
          v-for="option in selects.default"
          :value="option.value"
          :label="option.label"
          :key="option.label"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectDefault',
  props: ['value', 'title', 'disabled'],
  data() {
    return {
      selects: {
        simple: '',
        default: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  created() {
    this.populate();
    this.selects.simple = this.value;
  },
  methods: {
    populate() {
      const values = [
        {
          value: 'A',
          label: 'Active',
        },
        {
          value: 'I',
          label: 'Inactive',
        },
      ];
      this.selects.default = values.map(element => ({
        value: element.value,
        label: element.label,
      }));
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.selectrow {
  padding-top: 5px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
</style>
